













































































import { Vue, Component } from 'vue-property-decorator';
import { Tab, Tabs, Swipe, SwipeItem } from 'vant';
import SyPlayer from '@/components/SyPlayer.vue';
import CommentList from './components/CommentList.vue';
import CommentInput from './components/CommentInput.vue';
import { getContent } from './api/api';
import { VoteButton } from '@/components';
import { appShare, wxShareInfo } from '@/common/ts/common';
Vue.use(Tab)
  .use(Tabs)
  .use(Swipe)
  .use(SwipeItem);

@Component({
  name: 'Detail',
  components: {
    SyPlayer,
    CommentList,
    CommentInput,
    VoteButton,
  },
})
export default class Detail extends Vue {
  activeTabIndex: number = 0;
  voteName: string = '2019poject/2019new70years';
  VoteNum: number = 0;
  tabs: any[] = [
    { title: '特稿', id: 1 },
    { title: '视频', id: 2 },
    { title: '图集', id: 3 },
    { title: '手记', id: 4 },
  ];
  detailData: any = null;
  // lifecycle
  async created() {
    const res = await getContent(
      this.voteName,
      (this.$route.query as any).locationId,
    );
    this.detailData = res.data;
    this.VoteNum = this.detailData && this.detailData.voteNum;
    appShare({
      title: this.detailData.article.title,
      url: window.location.href,
      subtitle: this.detailData.article.abstract,
      classId: -1,
      id: -1,
      image: this.detailData.article.smallImg,
      type: 3,
    });
    wxShareInfo({
      title: this.detailData.article.title,
      subtitle: this.detailData.article.abstract,
      image: this.detailData.article.smallImg,
    });
  }
  // methods
  switchTab(tabindex: number) {
    this.activeTabIndex = tabindex;
    if (tabindex !== 1) {
      (this.$refs.player as any).dp.pause();
    }
  }
  navToArticle(url: string) {
    location.href = url;
  }
  votSuccess() {
    (this.VoteNum as any)++;
  }
}
